export async function getToken() {
    const refreshToken = localStorage.getItem("refreshToken");
    return refreshToken;
}